import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";

const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  const getAccessToken = () => {
    return localStorage.getItem("access_token");
  };

  const isTokenExpired = (token: string | null) => {
    if (!token) return true;
    const decoded: any = jwtDecode(token);
    const currentTime = Date.now() / 1000;
    return decoded.exp < currentTime;
  };

  const removeUrlParams = (param: string) => {
    const searchParams = new URLSearchParams(window.location.search);
    searchParams.delete(param);
    const newUrl =
      window.location.pathname +
      (searchParams.toString() ? "?" + searchParams.toString() : "");
    window.history.replaceState({}, "", newUrl);
  };

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    const tokenFromUrl = searchParams.get("token");

    if (tokenFromUrl) {
      localStorage.setItem("access_token", tokenFromUrl);
      localStorage.removeItem("refresh_token");
      removeUrlParams("token");
    }

    const accessToken = getAccessToken();

    if (!accessToken) {
      setIsAuthenticated(false);
      setIsLoading(false);
      return;
    }

    if (isTokenExpired(accessToken)) {
      localStorage.removeItem("access_token");
      localStorage.removeItem("refresh_token");
      alert("Su sesión ha expirado");
      setIsAuthenticated(false);
      location.reload();
    } else {
      setIsAuthenticated(true);
    }

    setIsLoading(false);
  }, []);

  if (isLoading) {
    return <div></div>;
  }

  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
